(function ($) {
  const apply = function () {
    const $user = $('#js-current-user').get(0);
    window.currentUser = $user ? $user.dataset : false;
  };

  $(document).on('turbolinks:load', () => apply());
  apply();
})(jQuery);
